import React, { useState } from 'react';
import { Button, Col, Modal, Row, Space, Typography } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import TraduccionScSp from './TraduccionScSp';
import TraduccionSpSc from './TraduccionSpSc';

const { Text } = Typography;

interface ModalTraducirProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  /** Lista de ítems a traducir — cada uno tiene tipoCom: 'SC-SP' | 'SP-SC' */
  items: any[];
  onProcesado?: (item: any) => void;
}

const ModalTraducir: React.FC<ModalTraducirProps> = ({
  open,
  setOpen,
  items,
  onProcesado,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const total       = items.length;
  const currentItem = items[currentIndex] ?? null;
  const isScSp      = currentItem?.tipoCom === 'SC-SP';

  const goNext = () => setCurrentIndex(i => Math.min(i + 1, total - 1));
  const goPrev = () => setCurrentIndex(i => Math.max(i - 1, 0));

  const handleClose = () => {
    setCurrentIndex(0);
    setOpen(false);
  };

  const handleProcesado = () => {
    onProcesado?.(currentItem);
    if (currentIndex < total - 1) {
      goNext();
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={handleClose}
      width={1100}
      title={
        <Row align="middle" gutter={8}>
          <Col>
            <Text strong style={{ fontSize: 16 }}>
              Traducción — {isScSp ? 'SC → SP' : 'SP → SC'}
            </Text>
          </Col>
        </Row>
      }
      footer={
        <Row justify="space-between" align="middle">
          {/* Navegación */}
          <Col>
            <Space>
              <Button
                icon={<LeftOutlined />}
                disabled={currentIndex === 0}
                onClick={goPrev}
              />
              <Text>
                {currentIndex + 1} de {total}
              </Text>
              <Button
                icon={<RightOutlined />}
                disabled={currentIndex === total - 1}
                onClick={goNext}
              />
            </Space>
          </Col>

          {/* Acciones */}
          <Col>
            <Space>
              <Button onClick={handleClose}>
                Cancelar
              </Button>
              <Button>
                Editar traducción
              </Button>
              <Button type="primary" onClick={handleProcesado}>
                Procesado
              </Button>
            </Space>
          </Col>
        </Row>
      }
      bodyStyle={{ padding: '16px 24px' }}
    >
      {currentItem && (
        isScSp
          ? <TraduccionScSp item={currentItem} />
          : <TraduccionSpSc item={currentItem} />
      )}

      {!currentItem && (
        <Row justify="center" style={{ padding: 40 }}>
          <Text type="secondary">No hay ítems seleccionados para traducir.</Text>
        </Row>
      )}
    </Modal>
  );
};

export default ModalTraducir;
